module.exports = __webpack_public_path__ + "img/03_Batten-Rafter Metal.54c36586.png";